<template>
   <div class="get-started">
      <!-- Header -->
      <h3 class="get-started__header">{{ getStartedContent.header || 'Ready to Get Started?' }}</h3>
      <!-- Paragraph -->
      <p class="get-started__para">
         {{ descriptionJoiner(description) }}
      </p>
      <!-- ctas -->
      <ChartButtons :framework="frameworkName" :get-started-ctas="getStartedContent.ctas || []" />
   </div>
</template>

<script>
import ChartButtons from './ChartButtons.vue';

export default {
   name: 'GetStarted',
   components: {
      ChartButtons,
   },
   props: {
      getStartedContent: {
         type: Object,
         default: () => {},
      },
      frameworkName: {
         type: String,
         default: 'js',
      },
   },
   computed: {
      description() {
         return this.frameworkName.indexOf('react') > -1
            ? this.getStartedContent.shortDescription
            : '';
      },
   },
};
</script>

<style lang="scss" scoped>
.get-started {
   background-color: #ffffff;
   border-radius: 4px;
   box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.04);
   padding: 27px 25px;
   &__header {
      line-height: 26px;
      margin-bottom: 1.5rem;
   }
   &__para {
      line-height: 24px;
      font-size: 14px;
      margin-bottom: 4rem;
   }
}
</style>
